<template>
  <v-container>
    <v-row class="justify-center align-center">
      <v-tooltip top nudge-right>
        <template v-slot:activator="{ on }">
          <v-img :src="src" height="100" width="200" contain v-on="on"></v-img>
        </template>
        <span>{{ $t("noData") }}</span>
      </v-tooltip>
    </v-row>
    <v-row v-if="!small" class="justify-center align-center mt-4">
      <span>{{ $t("noData") }}</span>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";

@Component({})
export default class LatestEntriesCardEmpty extends Vue {
  get src() {
    return AssetRepository.getAsset(false, AssetEnum.emptyData);
  }

  @Prop({ default: true })
  small!: boolean;
}
</script>
